import * as React from 'react';
import Wrapper from './Wrapper';

const Bold = Wrapper(props => (
  <svg
    width={38}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5 19.499H20a4.5 4.5 0 0 0 0-9h.5a3 3 0 0 0 0-6h-7M15.5 4.499v15M20 10.499h-4.5"
      stroke="#535B64"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export default Bold;
